/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
*/
import React from 'react';
import {AugmentedSmarterTrailerSensorData} from '@ion/core/src/types/entities';
import {getUserUnit} from '@ion/core/src/units/helpers';
import {convertWeightSensorData} from '@ion/dls/src/components/smarterTrailer/helper';
import EventTime from '@ion/dls/src/components/time/EventTime';
import {WeightSensorIcon} from '@ion/dls/src/icons/WeightSensorIcon';
import {useThemeContext} from '@ion/dls/src/theme/useThemeContext';

export interface WeightSensorProps {
  trailerData: AugmentedSmarterTrailerSensorData;
}

/**
 * @WeightSection
 *
 * Defines the Weight Sensor component which includes the trailer icon and the event time.
 *
 * ```typescript
 *
 * import {WeightSection} from '@ion/features/src/smarterTrailer';
 *
 * <WeightSection trailerData={trailerData} />
 *
 * ```
 *
 * @param trailerData - the smarter trailer data
 */
const WeightSection = ({trailerData}: WeightSensorProps) => {
  const {isCurrent}                 = useThemeContext();
  const {WMS: weightValueData}      = trailerData || {};
  const {messageTime}               = weightValueData.WE1 || {};
  const preferredUnit               = getUserUnit();
  const {value, units}              = convertWeightSensorData(weightValueData, preferredUnit);

  return (
    <>
      <WeightSensorIcon weight={value} units={units}/>
      <EventTime eventTime={messageTime} padding={isCurrent ? '0px' : '0px 15px 15px'}/>
    </>
  );
};

export default WeightSection;
